/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from '../../$$_gendir/node_modules/ngx-toastr/index.ngfactory';
import * as i4 from './app.component.ngfactory';
import * as i5 from '@angular/common';
import * as i6 from '@angular/platform-browser';
import * as i7 from '@angular/animations/browser';
import * as i8 from '@angular/platform-browser/animations';
import * as i9 from '@angular/animations';
import * as i10 from '@angular/http';
import * as i11 from '@angular/router';
import * as i12 from 'ng2-json-editor/src/shared/services/path-util.service';
import * as i13 from '../../app/core/services/common-api.service';
import * as i14 from '../../app/core/services/holdingpen-api.service';
import * as i15 from '../../app/core/services/record-api.service';
import * as i16 from '../../app/core/services/app-config.service';
import * as i17 from '../../app/core/services/record-cleanup.service';
import * as i18 from '../../app/core/services/dom-utils.service';
import * as i19 from '../../app/core/services/record-search.service';
import * as i20 from '../../app/core/services/save-preview-modal.service';
import * as i21 from '../../app/core/services/global-app-state.service';
import * as i22 from '../../app/core/services/workflow-error-converter.service';
import * as i23 from 'ngx-bootstrap/accordion/accordion.config';
import * as i24 from 'ngx-toastr';
import * as i25 from '../../app/app.router';
import * as i26 from '../../app/core/core.module';
import * as i27 from 'ngx-bootstrap/collapse/collapse.module';
import * as i28 from 'ngx-bootstrap/accordion/accordion.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.ToastNgFactory,i4.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),
          i0.ɵmpd(4608,i5.NgLocalization,i5.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(5120,
              i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,i0.ɵk,
              ([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),
          i0.ɵmpd(4608,i6.DomSanitizer,i6.ɵe,[i5.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,
              (null as any),[i6.DomSanitizer]),i0.ɵmpd(4608,i6.HAMMER_GESTURE_CONFIG,
              i6.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,i6.EVENT_MANAGER_PLUGINS,
              (p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i6.ɵDomEventsPlugin(p0_0),new i6.ɵKeyEventsPlugin(p1_0),
                    new i6.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i5.DOCUMENT,i5.DOCUMENT,i5.DOCUMENT,i6.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i6.EventManager,i6.EventManager,[i6.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i6.ɵDomSharedStylesHost,i6.ɵDomSharedStylesHost,[i5.DOCUMENT]),
          i0.ɵmpd(4608,i6.ɵDomRendererFactory2,i6.ɵDomRendererFactory2,[i6.EventManager,
              i6.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i7.AnimationDriver,i8.ɵc,([] as any[])),
          i0.ɵmpd(5120,i7.ɵAnimationStyleNormalizer,i8.ɵd,([] as any[])),i0.ɵmpd(4608,
              i7.ɵAnimationEngine,i8.ɵb,[i7.AnimationDriver,i7.ɵAnimationStyleNormalizer]),
          i0.ɵmpd(5120,i0.RendererFactory2,i8.ɵe,[i6.ɵDomRendererFactory2,i7.ɵAnimationEngine,
              i0.NgZone]),i0.ɵmpd(6144,i6.ɵSharedStylesHost,(null as any),[i6.ɵDomSharedStylesHost]),
          i0.ɵmpd(4608,i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i6.Meta,
              i6.Meta,[i5.DOCUMENT]),i0.ɵmpd(4608,i6.Title,i6.Title,[i5.DOCUMENT]),
          i0.ɵmpd(4608,i9.AnimationBuilder,i8.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
              i6.DOCUMENT]),i0.ɵmpd(4608,i10.BrowserXhr,i10.BrowserXhr,([] as any[])),
          i0.ɵmpd(4608,i10.ResponseOptions,i10.BaseResponseOptions,([] as any[])),
          i0.ɵmpd(5120,i10.XSRFStrategy,i10.ɵb,([] as any[])),i0.ɵmpd(4608,i10.XHRBackend,
              i10.XHRBackend,[i10.BrowserXhr,i10.ResponseOptions,i10.XSRFStrategy]),
          i0.ɵmpd(4608,i10.RequestOptions,i10.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i10.Http,i10.ɵc,[i10.XHRBackend,i10.RequestOptions]),i0.ɵmpd(5120,i11.ActivatedRoute,
              i11.ɵf,[i11.Router]),i0.ɵmpd(4608,i11.NoPreloading,i11.NoPreloading,
              ([] as any[])),i0.ɵmpd(6144,i11.PreloadingStrategy,(null as any),[i11.NoPreloading]),
          i0.ɵmpd(135680,i11.RouterPreloader,i11.RouterPreloader,[i11.Router,i0.NgModuleFactoryLoader,
              i0.Compiler,i0.Injector,i11.PreloadingStrategy]),i0.ɵmpd(4608,i11.PreloadAllModules,
              i11.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i11.ROUTER_INITIALIZER,
              i11.ɵi,[i11.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i11.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i12.PathUtilService,i12.PathUtilService,
              ([] as any[])),i0.ɵmpd(4608,i13.CommonApiService,i13.CommonApiService,
              [i10.Http]),i0.ɵmpd(4608,i14.HoldingpenApiService,i14.HoldingpenApiService,
              [i10.Http]),i0.ɵmpd(4608,i15.RecordApiService,i15.RecordApiService,[i10.Http]),
          i0.ɵmpd(4608,i16.AppConfigService,i16.AppConfigService,([] as any[])),i0.ɵmpd(4608,
              i17.RecordCleanupService,i17.RecordCleanupService,([] as any[])),i0.ɵmpd(4608,
              i18.DomUtilsService,i18.DomUtilsService,([] as any[])),i0.ɵmpd(4608,
              i19.RecordSearchService,i19.RecordSearchService,[i15.RecordApiService]),
          i0.ɵmpd(4608,i20.SavePreviewModalService,i20.SavePreviewModalService,([] as any[])),
          i0.ɵmpd(4608,i21.GlobalAppStateService,i21.GlobalAppStateService,([] as any[])),
          i0.ɵmpd(4608,i22.WorkflowErrorConverterService,i22.WorkflowErrorConverterService,
              [i12.PathUtilService]),i0.ɵmpd(4608,i23.AccordionConfig,i23.AccordionConfig,
              ([] as any[])),i0.ɵmpd(4608,i24.OverlayContainer,i24.OverlayContainer,
              ([] as any[])),i0.ɵmpd(4608,i24.Overlay,i24.Overlay,[i24.OverlayContainer,
              i0.ComponentFactoryResolver,i0.ApplicationRef]),i0.ɵmpd(4608,i24.ToastrService,
              i24.ToastrService,[i24.TOAST_CONFIG,i24.Overlay,i0.Injector,i6.DomSanitizer]),
          i0.ɵmpd(512,i5.CommonModule,i5.CommonModule,([] as any[])),i0.ɵmpd(512,i0.ErrorHandler,
              i1.RavenErrorHandler,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i11.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i11.ɵg,i11.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i6.ɵc(p0_0,p0_1),i11.ɵh(p1_0)];
              },[[2,i6.NgProbeToken],[2,i0.NgProbeToken],i11.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i6.BrowserModule,i6.BrowserModule,[[3,i6.BrowserModule]]),i0.ɵmpd(512,
              i8.BrowserAnimationsModule,i8.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i10.HttpModule,i10.HttpModule,([] as any[])),i0.ɵmpd(1024,i11.ɵa,
              i11.ɵd,[[3,i11.Router]]),i0.ɵmpd(512,i11.UrlSerializer,i11.DefaultUrlSerializer,
              ([] as any[])),i0.ɵmpd(512,i11.ChildrenOutletContexts,i11.ChildrenOutletContexts,
              ([] as any[])),i0.ɵmpd(256,i5.APP_BASE_HREF,'/editor',([] as any[])),
          i0.ɵmpd(256,i11.ROUTER_CONFIGURATION,{},([] as any[])),i0.ɵmpd(1024,i5.LocationStrategy,
              i11.ɵc,[i5.PlatformLocation,[2,i5.APP_BASE_HREF],i11.ROUTER_CONFIGURATION]),
          i0.ɵmpd(512,i5.Location,i5.Location,[i5.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,
              i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i11.ROUTES,
              () => {
                return [[{path:'holdingpen',loadChildren:'./holdingpen-editor/holdingpen-editor.module#HoldingpenEditorModule'},
                    {path:'record',loadChildren:'./record-editor/record-editor.module#RecordEditorModule'},
                    {path:'multieditor',loadChildren:'./multi-editor/multi-editor.module#MultiEditorModule'}]];
              },([] as any[])),i0.ɵmpd(1024,i11.Router,i11.ɵe,[i0.ApplicationRef,i11.UrlSerializer,
              i11.ChildrenOutletContexts,i5.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i11.ROUTES,i11.ROUTER_CONFIGURATION,[2,i11.UrlHandlingStrategy],
              [2,i11.RouteReuseStrategy]]),i0.ɵmpd(512,i11.RouterModule,i11.RouterModule,
              [[2,i11.ɵa],[2,i11.Router]]),i0.ɵmpd(512,i25.AppRouter,i25.AppRouter,
              ([] as any[])),i0.ɵmpd(512,i26.CoreModule,i26.CoreModule,([] as any[])),
          i0.ɵmpd(512,i27.CollapseModule,i27.CollapseModule,([] as any[])),i0.ɵmpd(512,
              i28.AccordionModule,i28.AccordionModule,([] as any[])),i0.ɵmpd(512,i24.ToastrModule,
              i24.ToastrModule,[[3,i24.ToastrModule]]),i0.ɵmpd(512,i1.AppModule,i1.AppModule,
              ([] as any[])),i0.ɵmpd(256,i24.TOAST_CONFIG,{positionClass:'toast-bottom-right'},
              ([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvaW5zcGlyZWhlcC9yZWNvcmQtZWRpdG9yL3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/app.module.ngfactory.ts